import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-solid-svg-icons';

import ConnectionDetails from './connection_details';

export default class UnconnectedRow extends React.Component {
  static propTypes = {
    connectableObject: PropTypes.shape({
      connections: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired
      })),
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired,
    onLinkMore: PropTypes.func.isRequired
  }

  renderDetails() {
    const { name, subtitle } = this.props.connectableObject;
    return <ConnectionDetails name={name} subtitle={subtitle} />;
  }

  render() {
    return (
      <Row>
        <Col lg={5} xs={5}>
          {this.renderDetails()}
        </Col>
        <Col lg={5} xs={4} />
        <Col className='text-right' xs={2}>
          <div
            className='text-primary clickable'
            name='link'
            onClick={this.props.onLinkMore}
          >
            <FontAwesomeIcon className='mr-2' icon={faLink}/> Link
          </div>
        </Col>
      </Row>
    );
  }
}
